import moment from 'moment';

import {
  CardTypes,
  PaymentFrequency,
  PaymentMethod,
} from 'scenes/common/types';
import { MotorFunnelState } from 'scenes/motor/types';
import { MotorFlowType } from '../flows/types';
import {
  getPreselectedPaymentFrequency,
  getPolicyStartDate,
} from './quoteSelectors';

export const getPaymentFrequency = (
  state: MotorFunnelState
): PaymentFrequency =>
  state.paymentDetails.paymentFrequency ?? PaymentFrequency.Unspecified;

export const isAnnualPayment = (state: MotorFunnelState): boolean =>
  getPaymentFrequency(state) === PaymentFrequency.Annually;

export const isMonthlyPayment = (state: MotorFunnelState): boolean =>
  getPaymentFrequency(state) === PaymentFrequency.Monthly;

export const getPaymentMethodOptions = (
  state: MotorFunnelState
): PaymentMethod[] =>
  isMonthlyPayment(state)
    ? [PaymentMethod.DirectDebit, PaymentMethod.CreditCard]
    : [PaymentMethod.DirectDebit, PaymentMethod.CreditCard, PaymentMethod.BPAY];

export const getPaymentDate = (state: MotorFunnelState): string =>
  state.paymentDetails.paymentDate ?? '';

export const getPaymentMethod = (state: MotorFunnelState): PaymentMethod =>
  state.paymentDetails.paymentMethod ?? PaymentMethod.Unspecified;

export const isCreditCardPayment = (state: MotorFunnelState): boolean =>
  getPaymentMethod(state) === PaymentMethod.CreditCard;

export const isDirectDebitPayment = (state: MotorFunnelState): boolean =>
  getPaymentMethod(state) === PaymentMethod.DirectDebit;

export const getPaymentCardType = (state: MotorFunnelState): CardTypes =>
  state.paymentDetails.paymentCardType ?? CardTypes.Unspecified;

export const getPaymentDateOptions = (state: MotorFunnelState) => {
  const policyStartDate = getPolicyStartDate(state);
  const todaysDateOption = {
    label: 'Pay now',
    value: moment().format('YYYY-MM-DD'),
  };
  const policyStartDateOption = {
    label: `Policy Start Date: ${moment(policyStartDate, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    )}`,
    value: policyStartDate,
  };

  return moment().isSame(policyStartDate, 'day')
    ? [policyStartDateOption]
    : [todaysDateOption, policyStartDateOption];
};

export const getSelectedPaymentFrequency = (
  state: MotorFunnelState
): PaymentFrequency =>
  state.flow === MotorFlowType.PaymentDetails
    ? getPaymentFrequency(state)
    : getPreselectedPaymentFrequency(state);
